import { Box, Typography, Button, Stack, Divider, Grid } from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import { keyframes } from '@mui/system';

const glow = keyframes`
  0%,100% { box-shadow: 0 0 30px rgba(34,197,94,.2); }
  50%      { box-shadow: 0 0 60px rgba(34,197,94,.45); }
`;

export const CTA = () => (
  <Box sx={{
    py: 14, px: 3, textAlign: 'center',
    background: 'linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%)',
    borderTop: '1px solid rgba(34,197,94,.15)',
  }}>
    <Typography variant="h2" sx={{ color: '#0f172a', fontWeight: 900, mb: 2, fontSize: { xs: '2rem', md: '3.2rem' } }}>
      Prêt à révéler les{' '}
      <Box component="span" sx={{
        background: 'linear-gradient(90deg, #16a34a, #22c55e, #4ade80)',
        WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
      }}>
        prochains champions ?
      </Box>
    </Typography>
    <Typography variant="h6" sx={{ color: '#94a3b8', mb: 6, fontWeight: 300 }}>
      Rejoignez des centaines de clubs et académies qui font confiance à notre plateforme.
    </Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
      <Button variant="contained" size="large" sx={{
        background: 'linear-gradient(135deg, #22c55e, #16a34a)',
        color: '#fff', fontWeight: 800, px: 6, py: 2, borderRadius: 3, fontSize: '1.05rem',
        animation: `${glow} 3s ease-in-out infinite`,
        '&:hover': { background: 'linear-gradient(135deg, #16a34a, #15803d)', transform: 'translateY(-3px)' },
        transition: 'all .3s',
      }}>
        Créer un compte gratuit
      </Button>
      <Button variant="outlined" size="large" sx={{
        borderColor: 'rgba(34,197,94,.35)', borderWidth: '1.5px',
        color: '#16a34a', px: 6, py: 2, borderRadius: 3, fontSize: '1.05rem',
        '&:hover': { borderColor: '#22c55e', borderWidth: '1.5px', bgcolor: 'rgba(34,197,94,.06)' },
        transition: 'all .3s',
      }}>
        Contacter l'équipe
      </Button>
    </Stack>
  </Box>
);

export const Footer = () => (
  <Box sx={{ bgcolor: '#f8fafc', px: 4, py: 8, borderTop: '1px solid rgba(34,197,94,.1)' }}>
    <Grid container spacing={4} maxWidth={1100} mx="auto">
      <Grid item xs={12} md={4}>
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <Box sx={{
            width: 30, height: 30, borderRadius: '8px',
            background: 'linear-gradient(135deg, #22c55e, #16a34a)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(34,197,94,.25)',
          }}>
            <SportsSoccerIcon sx={{ color: '#fff', fontSize: 18 }} />
          </Box>
          <Typography variant="h6" sx={{
            fontWeight: 800,
            background: 'linear-gradient(135deg, #15803d, #22c55e)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}>
            ProPlayeur
          </Typography>
        </Stack>
        <Typography variant="body2" sx={{ color: '#94a3b8', lineHeight: 1.9 }}>
          La plateforme de référence pour la gestion des talents footballistiques et des tournois en Afrique.
        </Typography>
      </Grid>
      {[
        { title: 'Produit', links: ['Fonctionnalités', 'Tarifs', 'Témoignages', 'Changelog'] },
        { title: 'Ressources', links: ['Documentation', 'API', 'Blog', 'Support'] },
        { title: 'Légal', links: ['Confidentialité', 'CGU', 'Cookies'] },
      ].map((col, i) => (
        <Grid item xs={6} md={2.67} key={i}>
          <Typography variant="subtitle2" sx={{ color: '#0f172a', fontWeight: 700, mb: 2 }}>{col.title}</Typography>
          {col.links.map(l => (
            <Typography key={l} variant="body2" sx={{
              color: '#94a3b8', mb: 1, cursor: 'pointer',
              '&:hover': { color: '#16a34a' }, transition: 'color .2s',
            }}>
              {l}
            </Typography>
          ))}
        </Grid>
      ))}
    </Grid>
    <Divider sx={{ borderColor: 'rgba(34,197,94,.1)', my: 5, maxWidth: 1100, mx: 'auto' }} />
    <Typography variant="caption" sx={{ color: '#cbd5e1', display: 'block', textAlign: 'center' }}>
      © 2025 ProPlayeur. Tous droits réservés. Conçu avec passion pour le football africain.
    </Typography>
  </Box>
);